import { Component } from '@angular/core';

@Component({
  selector: 'how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss']
})
export class HowItWorksComponent {
  list = [
    {
      number: `1`,
      title: $localize`:@@signUpEffortlesslyTitle:Sign Up Effortlessly`,
      subtitle: $localize`:@@signUpEffortlesslySubtitle:Begin your journey with us by creating your chef profile. It’s quick, easy, and free. Tell us about your culinary expertise, your kitchen, and what makes your dishes special.`,
      image: 'assets/merchant-landing-page/work-together-1.png',
      direction: 'left'
    },

    {
      number: `2`,
      title: $localize`:@@showcaseMenuTitle:Showcase Your Menu`,
      subtitle: $localize`:@@showcaseMenuSubtitle:Upload your menu with enticing descriptions and high-quality images. Set your prices, availability, and customize your offerings to suit your style.`,
      image: 'assets/merchant-landing-page/work-together-2.png',
      direction: 'right'
    },

    {
      number: `3`,
      title: $localize`:@@receiveOrdersTitle:Receive and Fulfill Orders`,
      subtitle: $localize`:@@receiveOrdersSubtitle:Watch orders from enthusiastic food lovers flow in. Our platform handles payment processing seamlessly, so you can focus on preparing delicious meals.`,
      image: 'assets/merchant-landing-page/work-together-3.png',
      direction: 'left'
    },
    {
      number: `4`,
      title: $localize`:@@deliverTitle:Deliver with Ease`,
      subtitle: $localize`:@@deliverSubtitle:Leverage our integrated delivery services to get your food to customers hot and fresh. Track orders from kitchen to doorstep, ensuring a great customer experience.`,
      image: 'assets/merchant-landing-page/work-together-4.png',
      direction: 'right'
    },

    {
      number: `5`,
      title: $localize`:@@growBusinessTitle:Grow Your Business`,
      subtitle: $localize`:@@growBusinessSubtitle:Utilize our tools and insights to expand your reach, optimize your menu, and grow your customer base. Enjoy increased earnings and repeat customers.`,
      image: 'assets/merchant-landing-page/work-together-5.png',
      direction: 'left'
    },
  ]
}
